var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXxs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24.16V9.23291L21.7755 22.0056V36.9327L0 24.16Z",
    fill: "url(#paint0_linear_2934_5779)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8485 27.7003V12.7734L21.7749 22.0067V36.9336L37.8485 27.7003Z",
    fill: "url(#paint1_linear_2934_5779)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.23327L16.0736 0L37.8491 12.7727L21.7755 22.006L0 9.23327Z",
    fill: "url(#paint2_linear_2934_5779)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53538 18.1064L8.30652 18.5681V19.235L9.68285 18.6707V21.851L10.1252 22.1588V18.9785L11.5016 21.3894V20.7225L10.2727 18.6707L9.53538 18.1064Z",
    fill: "#36AB4B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7587 29.7515L23.7418 30.5209L24.2825 30.2132L23.1519 29.3924L25.6096 28.0587V27.5971L23.1519 28.9308L24.3316 26.8276L23.7909 27.1354L22.7587 28.9308V29.7515Z",
    fill: "#36AB4B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.014 20.7231L36.0801 19.9536L35.5885 20.2101L36.6208 21.0821L34.4088 22.2619V22.7236L36.6208 21.5438L35.5885 23.5443L36.0801 23.2878L36.9649 21.5438L37.014 20.7231Z",
    fill: "#36AB4B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01235 25.9567L7.66827 25.7515V23.4431L6.9801 23.2892V22.9814L7.9632 23.1866L8.01235 23.2379V25.9567Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1263 27.1876L9.78222 26.9824V24.6741L9.09406 24.5202V24.2124L10.0771 24.4176L10.1263 24.4689V27.1876Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7314 27.5978C12.7806 27.8543 12.6823 28.1621 12.5348 28.3673C12.3874 28.4698 12.1907 28.4698 11.8958 28.2647C11.65 28.1108 11.4043 27.8543 11.2568 27.5978C11.1093 27.29 11.0602 26.931 11.0602 26.5719V26.1615C11.0602 26.0076 11.0602 25.9051 11.1093 25.7512C11.1585 25.5973 11.2076 25.4947 11.306 25.3921C11.4534 25.2895 11.65 25.2895 11.945 25.4947C12.1907 25.6486 12.4365 25.9051 12.584 26.1615C12.7314 26.4693 12.7806 26.8284 12.7806 27.1875V27.5978H12.7314ZM12.4365 26.931C12.4365 26.6745 12.3874 26.418 12.3382 26.2128C12.2399 26.0076 12.1416 25.8538 11.945 25.8025C11.7975 25.6999 11.65 25.6999 11.5517 25.8025C11.4534 25.9564 11.4043 26.1615 11.4534 26.3667V26.931C11.4534 27.1875 11.5026 27.4439 11.5517 27.6491C11.65 27.8543 11.7483 28.0082 11.945 28.1108C12.0924 28.2134 12.2399 28.2134 12.3382 28.1108C12.4365 27.9569 12.4857 27.7517 12.4857 27.5465L12.4365 26.931Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6577 28.0091L26.4949 29.1889V28.8812L27.6254 26.9832C27.7729 26.778 27.8712 26.5216 27.9695 26.3164C28.0187 26.1625 28.0678 26.0599 28.0678 25.906C28.0678 25.8547 28.0678 25.7521 28.0187 25.7008C27.9695 25.6495 27.9695 25.5982 27.8712 25.5469C27.822 25.5469 27.7237 25.4956 27.6746 25.5469C27.6254 25.5469 27.5271 25.5982 27.478 25.6495C27.2813 25.7521 27.1339 25.906 26.9864 26.1112C26.8881 26.2651 26.8389 26.4703 26.8389 26.7267L26.3965 26.9832C26.3965 26.6754 26.4949 26.3677 26.6915 26.1112C26.8881 25.8034 27.1339 25.5469 27.478 25.393C27.5763 25.2905 27.7237 25.2392 27.822 25.2392C27.9695 25.1879 28.0678 25.1879 28.2153 25.2392C28.4119 25.2905 28.461 25.4443 28.461 25.7521C28.3627 26.3164 28.1661 26.8293 27.822 27.2397L26.9373 28.676L28.6085 27.7527L28.6577 28.0091Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7205 23.751C33.7205 24.1614 33.6713 24.623 33.4747 24.9821C33.2781 25.3412 33.0323 25.5976 32.6882 25.7515C32.3441 25.9567 32.0984 25.9567 31.9017 25.8541C31.8034 25.7515 31.7051 25.5976 31.656 25.4438C31.6068 25.2899 31.6068 25.136 31.6068 24.9821V24.4178C31.6068 24.0075 31.7051 23.5971 31.8526 23.1865C32.0492 22.8274 32.295 22.5709 32.6391 22.417C33.0323 22.2119 33.2289 22.2119 33.4255 22.3145C33.573 22.4683 33.6713 22.7761 33.6713 23.2378L33.7205 23.751ZM33.3272 23.3917C33.3764 23.1352 33.3272 22.8787 33.1798 22.6735C33.0814 22.5709 32.934 22.5709 32.6882 22.6735C32.4916 22.7761 32.295 22.9813 32.1967 23.1865C32.0984 23.443 32.0492 23.751 32.0492 24.0075V24.6743C32 24.9308 32.0984 25.1873 32.1967 25.3925C32.295 25.4951 32.4424 25.4951 32.6882 25.3925C32.8848 25.2899 33.0323 25.0847 33.1306 24.8795C33.2289 24.623 33.2781 24.3153 33.2781 24.0588V23.3917H33.3272Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1004 8.15528V7.02677C29.1004 7.02677 28.6089 5.4366 26.9868 4.66716C25.3155 3.89772 24.3816 2.66662 20.3017 2.76921C16.1727 2.8718 13.0759 5.59049 13.0759 5.59049L13.8133 5.12882V6.6164C13.0268 7.12936 12.5352 7.48844 12.4861 7.53973L12.8302 7.69362C12.8302 7.69362 13.7641 6.92418 15.1896 6.20604C16.5168 5.53919 18.2863 4.82105 20.4983 4.71846C22.2188 4.61586 23.8409 4.97494 25.3155 5.79567L27.1834 6.87288C28.019 7.38584 28.6089 7.9501 28.8546 8.56565C28.8546 8.51436 28.9038 8.46306 28.9038 8.41176C29.0021 8.51435 29.0513 8.61695 29.0513 8.61695L29.1004 8.15528Z",
    fill: "url(#paint3_linear_2934_5779)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4929 9.43845C29.4929 9.38716 29.4929 9.38716 29.4929 9.33586V7.5918L28.6081 9.54104L25.6096 11.9007L25.5113 12.0545V13.5421C24.6757 14.0038 24.0367 14.3116 24.0367 14.3116L24.2825 14.5167C24.3316 14.5167 25.5605 13.9525 26.8877 13.0805C28.1165 12.2084 29.2962 11.1312 29.4929 9.74623C29.4437 9.64364 29.4929 9.59234 29.4929 9.43845Z",
    fill: "#B4CBB9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8292 7.28401L13.6648 6.61716V4.77051L12.8292 5.12958L12.2885 5.53994V7.59178L12.8292 7.28401Z",
    fill: "#E8E7EC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4442 7.89856C29.2476 9.28355 28.0679 10.3608 26.839 11.1815C26.3475 11.4893 25.8559 11.7971 25.4627 12.0022L25.1678 11.797C25.561 11.5919 26.0526 11.2841 26.5441 10.9763C27.7238 10.2069 28.8544 9.12966 29.051 7.84726C29.1985 6.82134 28.5595 5.84672 27.1831 4.97469L25.3152 3.89742C23.8406 3.07669 22.2185 2.71767 20.4981 2.82026C18.2861 2.92285 16.5166 3.64099 15.1894 4.30784C14.6487 4.56432 14.2063 4.8721 13.8131 5.12858L13.5181 4.92334C13.9114 4.66686 14.3538 4.41043 14.9436 4.10266C16.3199 3.38452 18.1387 2.66637 20.4981 2.56378C22.366 2.46119 24.0864 2.87156 25.6102 3.74359L27.5272 4.8208C28.9527 5.74413 29.6409 6.82134 29.4442 7.89856Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6648 4.82227L14.0089 5.07875L13.419 5.643L12.8783 6.05337L12.2885 5.54041L12.8292 5.13004L13.6648 4.82227Z",
    fill: "#F6F6F8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4205 7.79632L14.0104 6.92429V5.07764L13.4205 5.64189L12.8798 6.05226V8.0528L13.4205 7.79632Z",
    fill: "#CFCFDA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3315 14.1571L25.1671 13.4902V11.6436L24.3315 12.0026L23.7908 12.413V14.4648L24.3315 14.1571Z",
    fill: "#A0A6C0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1662 11.6436L25.6086 12.0026L24.9696 12.4643L24.4289 12.8747L23.8391 12.413L24.3797 12.0026L25.1662 11.6436Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9697 14.619L25.6087 13.7983V11.9517L24.9697 12.4133L24.429 12.8237V14.8755L24.9697 14.619Z",
    fill: "#D7E3DA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8738 15.236C22.9552 13.3893 22.9552 11.3375 21.8738 10.7219C20.8415 10.1064 19.121 11.081 18.0396 12.979C16.9582 14.8256 16.9582 16.8775 18.0396 17.493C19.121 18.1086 20.8415 17.0826 21.8738 15.236Z",
    fill: "#3D424C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3653 10.9786L21.8737 10.7222L17.9905 17.4419L19.1702 18.1088L22.8076 11.2351L22.3653 10.9786Z",
    fill: "#3D424C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7096 15.6974C23.791 13.8508 23.791 11.7989 22.7096 11.1834C21.6773 10.5678 19.9569 11.5424 18.8755 13.4404C17.7941 15.287 17.7941 17.3389 18.8755 17.9544C19.9569 18.57 21.6773 17.5954 22.7096 15.6974Z",
    fill: "#464B54"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9058 15.7995C23.9872 13.9528 23.9872 11.901 22.9058 11.2854C21.8735 10.6699 20.1531 11.6445 19.0717 13.5424C17.9903 15.3891 17.9903 17.4409 19.0717 18.0565C20.104 18.672 21.8244 17.6461 22.9058 15.7995Z",
    fill: "#41464F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6931 11.8492L23.0541 11.4901C22.5625 11.131 21.8252 11.131 21.0387 11.5927C19.5641 12.4647 18.3843 14.5166 18.3843 16.2606C18.3843 17.184 18.7284 17.8508 19.3183 18.056L19.9573 18.4151L20.1048 18.1073C20.3997 18.056 20.6947 17.9534 21.0387 17.7482C22.5134 16.8762 23.6931 14.773 23.6931 13.029C23.6931 12.6186 23.6439 12.3108 23.4965 12.0544L23.6931 11.8492Z",
    fill: "url(#paint4_linear_2934_5779)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.873 13.4389L24.1848 12.3104C24.1848 12.2591 24.1357 12.2078 24.0865 12.1565V12.1052C23.595 11.4896 22.8085 11.4383 21.8746 11.9513C20.3999 12.8233 19.2202 14.9778 19.2202 16.6705C19.2202 17.6452 19.6135 18.2607 20.2033 18.5172C20.3016 18.5685 20.3999 18.5685 20.4982 18.5685L21.3339 18.7737L21.6288 18.3633C21.7271 18.312 21.8254 18.2607 21.8746 18.2094C23.1526 17.44 24.2831 15.6959 24.4798 14.1057L24.873 13.4389Z",
    fill: "url(#paint5_linear_2934_5779)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2819 16.7231C25.2158 15.0817 25.2158 13.235 24.2819 12.6708C23.3479 12.1065 21.8241 12.9785 20.8902 14.6713C19.9563 16.3128 19.9563 18.1594 20.8902 18.7237C21.8241 19.2879 23.3479 18.3646 24.2819 16.7231Z",
    fill: "#D7E3DA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9866 16.5173C24.7731 15.1323 24.7731 13.6447 23.9866 13.1831C23.2001 12.7214 21.9221 13.4395 21.1848 14.8245C20.3983 16.2095 20.3983 17.6971 21.1848 18.1588C21.9712 18.6717 23.2001 17.9023 23.9866 16.5173Z",
    fill: "#36AB4B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2982 13.3369L22.61 15.6965L21.037 17.6457C21.2337 17.9022 21.4794 18.0561 21.8235 18.0561L22.61 15.7478L24.1829 13.7472C23.9863 13.4395 23.6914 13.2856 23.2982 13.3369Z",
    fill: "#D7E3DA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5342 5.84905L12.78 5.43869L11.7477 5.2848C11.4037 5.2335 10.9613 5.33609 10.5189 5.59257C9.19169 6.41331 8.11029 8.31126 8.11029 9.85013C8.11029 10.4144 8.25776 10.8248 8.50353 11.1325L9.14254 11.8507L9.33916 11.4916C9.68324 11.4916 10.0765 11.389 10.4697 11.1325C11.7969 10.3631 12.8783 8.46514 12.8783 6.87497C12.8783 6.56719 12.7308 6.15683 12.5342 5.84905Z",
    fill: "url(#paint6_linear_2934_5779)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1067 6.05249L13.1236 5.59083C12.632 5.38565 12.0422 5.38565 11.3049 5.79601C9.83022 6.66805 8.65051 8.77118 8.65051 10.5152C8.65051 11.336 8.94544 11.9515 9.38783 12.2593L10.1743 12.8236L10.4201 12.4132C10.715 12.3619 11.0099 12.2593 11.354 12.0541C12.8287 11.1821 14.0084 9.07895 14.0084 7.33489C14.0084 7.02712 13.9592 6.71934 13.9101 6.46286L14.1067 6.05249Z",
    fill: "#DAEBDE"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9097 10.4654C14.9419 8.61872 14.9419 6.66947 13.9097 6.05392C12.8774 5.43837 11.2062 6.41299 10.1739 8.25964C9.14166 10.1063 9.14166 12.0555 10.1739 12.6711C11.2062 13.2866 12.8774 12.312 13.9097 10.4654Z",
    fill: "#CFCFDA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0591 10.5666C15.1405 8.71991 15.1405 6.66807 14.0591 6.05252C13.0268 5.43697 11.3064 6.41159 10.225 8.30954C9.14359 10.1562 9.14359 12.208 10.225 12.8236C11.2572 13.4391 12.9777 12.4132 14.0591 10.5666Z",
    fill: "#3D424C"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8942 6.56667L14.1077 6.05371L10.1262 12.7735L10.9126 13.2351L14.8942 6.56667Z",
    fill: "#3D424C"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6974 10.9767C15.7788 9.13006 15.7788 7.07822 14.6974 6.46267C13.6651 5.84712 11.9447 6.82174 10.8633 8.71969C9.7819 10.5663 9.7819 12.6182 10.8633 13.2337C11.9447 13.8493 13.6651 12.8234 14.6974 10.9767Z",
    fill: "#41464F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2549 10.7199C15.0413 9.38616 15.0413 7.89858 14.2549 7.43692C13.4684 6.97525 12.2887 7.6934 11.5022 9.02709C10.7157 10.3608 10.7157 11.8484 11.5022 12.31C12.2395 12.7717 13.4684 12.0535 14.2549 10.7199Z",
    fill: "#3D424C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0084 10.5668C14.6966 9.38699 14.6966 8.10459 14.0084 7.69423C13.3202 7.28386 12.2388 7.9507 11.5507 9.13051C10.8625 10.3103 10.8625 11.5927 11.5507 12.0031C12.2388 12.3622 13.3202 11.7466 14.0084 10.5668Z",
    fill: "#393842"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7143 10.3626C14.3042 9.3367 14.3042 8.20819 13.7143 7.84912C13.1244 7.49005 12.1905 8.05431 11.6007 9.08022C11.0108 10.1061 11.0108 11.2347 11.6007 11.5937C12.1414 11.9528 13.1244 11.3885 13.7143 10.3626Z",
    fill: "#3D424C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4261 23.751L30.0821 23.9562L29.4431 24.7256L29.5414 25.0334L30.0329 24.4178V27.4956L30.4261 27.2904V23.751Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2934_5779",
    x1: 15.8712,
    y1: 20.3172,
    x2: -1.09474,
    y2: 28.9596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2934_5779",
    x1: 36.2254,
    y1: 26.1635,
    x2: 15.8534,
    y2: 22.3805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2934_5779",
    x1: 31.4629,
    y1: 17.5542,
    x2: -8.84201,
    y2: -1.76412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#EBEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2934_5779",
    x1: 26.2037,
    y1: 5.65609,
    x2: 14.8457,
    y2: 5.94249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4CBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E3DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2934_5779",
    x1: 19.687,
    y1: 18.0467,
    x2: 22.5768,
    y2: 11.5859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2934_5779",
    x1: 20.5897,
    y1: 18.4381,
    x2: 23.3149,
    y2: 11.8196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0F4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2396,
    stopColor: "#ABD1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2934_5779",
    x1: 9.17464,
    y1: 11.5657,
    x2: 11.8682,
    y2: 5.62433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0F4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2396,
    stopColor: "#ABD1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXxs);
export default __webpack_public_path__ + "static/media/xxs.d2683547f930a45a0ea0fe483491b89a.svg";
export { ForwardRef as ReactComponent };